var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.685 15.408c3.861 0.025 6.935-3.208 6.974-7.292 0.025-3.989-3.082-7.313-6.898-7.315-3.878-0.003-6.835 3.187-6.963 7.036-0.138 4.147 2.949 7.546 6.887 7.572zM22.041 23.026c-0.17 0.469-0.512 0.617-1.018 0.616-6.655-0.011-13.31-0.017-19.965 0.002-0.984 0.003-1.14-0.502-1.026-1.23 0.202-1.294 0.947-2.287 1.927-3.123 1.889-1.61 4.136-2.506 6.571-3.002 0.995-0.202 2.006-0.314 3.019-0.234 3.473 0.274 6.608 1.34 9.102 3.809 0.728 0.721 1.224 1.582 1.343 2.611 0.002 0.017 0.016 0.034 0.029 0.050 0.006 0.007 0.013 0.015 0.018 0.023v0.477zM13.156 25.53l-0.024 4.598c0 0 16.099-1.667 18.442-2.359 1.132-1.271-0.349-2.117-0.349-2.117-1.121-0.23-18.068-0.122-18.068-0.122zM6.159 30.142c-2.389-2.384-4.677 0.543-4.677 0.543s3.139-7.991 10.553-5.149l-0.026 4.599c0 0-3.462 2.392-5.851 0.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArtist);
export default __webpack_public_path__ + "static/media/icon-artist.cb57e024692917e242799f65f7891537.svg";
export { ForwardRef as ReactComponent };